<template>
  <PieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    class="make-a-copy"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import { mapActions, mapGetters } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'PostByGroupPieChart',
  components: {
    PieChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: {},
    };
  },
  computed: {
    ...mapGetters('dashboard', ['activeDashboardFilters', 'activeGlobalFilter']),
    series() {
      return this.extractDataForPieChart();
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', ['getWarroomService']),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringMultibar',
        serviceParams: {
          type: 'names',
        },
      })
        .then(response => {
          this.rawSeries = response.data || {};
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    extractDataForPieChart() {
      if (!this.rawSeries.all) {
        return [];
      }

      const filterValues = this.$attrs.filter?.names?.value || this.activeGlobalFilter?.names?.value;

      let filteredData = this.rawSeries.all;
      if (filterValues) {
        filteredData = this.rawSeries.all.filter(item => filterValues.includes(item.name));
      }

      return filteredData.map(item => ({
        name: item.name,
        y: item.total,
      }));
    },
  },
};
</script>
